export default ({ small, status }) => {
    if (small)
        return (
            <div className="flex text-xs sm:text-sm whitespace-nowrap w-full">
                {Array.from({ length: 4 }).map((item, index) => (
                    <div key={index} className="relative flex-1 flex justify-center">
                        {index === 0 ? null : (
                            <div
                                className={`absolute left-1/2 -translate-x-full top-1/2 -translate-y-1/2 
                            ${index >= status ? "bg-shade" : "bg-primary"}
                             z-0 w-full h-[2px]`}
                            />
                        )}
                        <div
                            className={`relative z-10 ${
                                index >= status ? "bg-shade" : "bg-primary"
                            } w-[10px] h-[10px] rounded-full`}
                        />
                    </div>
                ))}
            </div>
        );
    else
        return (
            <div className="flex text-xs sm:text-sm whitespace-nowrap py-2 mt-6 w-full">
                {["Paid", "Order Created", "Preparing", "Completed"].map((item, index) => (
                    <div key={index} className="relative flex-1 flex justify-center">
                        <p
                            className={`${
                                index >= status ? "text-shade" : "text-primary"
                            } absolute -top-6 left-1/2 -translate-x-1/2`}
                        >
                            {item}
                        </p>
                        {index === 0 ? null : (
                            <div
                                className={`absolute left-1/2 -translate-x-full top-1/2 -translate-y-1/2 
                        ${index >= status ? "bg-shade" : "bg-primary"}
                        z-0 w-full h-2`}
                            />
                        )}
                        <div
                            className={`relative z-10 
                        ${index >= status ? "bg-shade" : "bg-primary"}
                        w-6 h-6 rounded-full`}
                        />
                    </div>
                ))}
            </div>
        );
};
